import CategoryManagerContainer from "../../container/admin/category-manager";

const CategoryManager = () => {
    return <CategoryManagerContainer />;
};

export default CategoryManager;